import { TeamInstructionActionSet, TeamInstructionKindForPermissionGrants } from './constants';

export const getAddMaintainersSemanticPatchInstructions = (memberIDs: string[]) => [
  {
    actionSet: TeamInstructionActionSet.MAINTAIN_TEAM,
    actions: [],
    kind: TeamInstructionKindForPermissionGrants.ADD_PERMISSION_GRANTS,
    memberIDs,
  },
];
